import { Model } from "react3l-common";
import { Field } from "react3l-decorators";
import { Responsibility } from "models/Responsibility";
import { Role } from "models/Role";

export class ResponsibilityRoleMapping extends Model {
  @Field(Number)
  public responsibilityId?: number;

  @Field(Number)
  public roleId?: number;

  public responsibility?: Responsibility;

  public role?: Role;
}
